/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import * as React from "react";
import styled from "styled-components";

import Navigation from "@src/components/modules/NavigationModule/Navigation";
import TopBar from "@src/components/modules/TemplateModule/TopBar";
import { ThemePalette } from "@src/components/Theme";

/*
 * Details pages in the Ops Console frame: the Swift sidebar (the section this item belongs to is
 * highlighted), the shared top bar (breadcrumbs, search, notifications, Refresh) and a centred
 * workspace with the item's header card and its content.
 *
 * The top bar is the template's own, as on list pages; `pageHeaderComponent` is still accepted
 * for the pages that pass one, but is no longer mounted (it used to be the top bar, with the
 * notifications and user menu that now live in the top bar and the sidebar).
 */
const Wrapper = styled.div<any>`
  display: flex;
  height: 100%;
  min-height: 0;
  background: ${ThemePalette.grayscale[7]};
`;
const Main = styled.div<any>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`;
const Scroll = styled.div<any>`
  flex-grow: 1;
  overflow: auto;
  padding: 24px 24px 24px 24px;
  @media (max-width: 720px) {
    padding: 16px;
  }
`;
const Inner = styled.div<any>`
  max-width: 1280px;
  min-width: 900px;
  margin: 0 auto;
  /* A phone: the page fits the screen (no sideways page scroll); wide tables scroll inside. */
  @media (max-width: 960px) {
    min-width: 0;
  }
  display: flex;
  flex-direction: column;
`;
const ContentHeader = styled.div<any>``;
const Content = styled.div<any>`
  padding: 24px 0 0 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
export type Props = {
  pageHeaderComponent?: React.ReactNode;
  contentHeaderComponent: React.ReactNode;
  contentComponent: React.ReactNode;
  style?: any;
  contentStyle?: any;
};
const sectionOf = () => window.location.pathname.split("/").filter(Boolean)[0] || "dashboard";
const DetailsTemplate = (props: Props) => (
  <Wrapper style={props.style}>
    <Navigation currentPage={sectionOf()} />
    <Main>
      <TopBar />
      <Scroll>
        <Inner>
          <ContentHeader>{props.contentHeaderComponent}</ContentHeader>
          <Content style={props.contentStyle}>{props.contentComponent}</Content>
        </Inner>
      </Scroll>
    </Main>
  </Wrapper>
);

export default DetailsTemplate;
